import { useCallback } from 'react';
import { saveCampaign } from '../api/CampaignsAssociation';
import { useCampaignsContext } from '../CampaignsProvider';
import { SENTRY_KEYS } from 'campaigns-lib/constants/sentry';
import Raven from 'raven-js';
import { useDataFetchingClient } from 'data-fetching-client';
import { GET_ASSOCIATED_CAMPAIGN_FIELD_NAME } from './useFetchAssociatedCampaign';
export function useHandleCampaignChange({
  objectType,
  onChange = () => {},
  save = true,
  selectedCampaignGuids,
  selectedAssetCrmId,
  setSelectedCampaignGuids,
  onSuccess = () => {},
  onFailure = () => {}
}) {
  const {
    setUpdatedCampaigns
  } = useCampaignsContext();
  const client = useDataFetchingClient();
  return useCallback(({
    target: {
      value: updatedCampaignGuids
    }
  }, selectOptions, selectedOption) => {
    const updatedCampaignGuidsArray = Array.isArray(updatedCampaignGuids) ? updatedCampaignGuids : [updatedCampaignGuids];
    if (save && selectedAssetCrmId) {
      saveCampaign({
        objectType,
        selectedAssetCrmId,
        currentCampaignGuids: selectedCampaignGuids,
        updatedCampaignGuids: updatedCampaignGuidsArray,
        onSuccess,
        onFailure
      }).then(() => {
        client.cache.evict({
          fieldName: GET_ASSOCIATED_CAMPAIGN_FIELD_NAME
        });
      }).catch(error => {
        Raven.captureException(error, {
          fingerprint: [SENTRY_KEYS.CAMPAIGNS_PLATFORM_UPDATE_FAILED],
          tags: {
            lib: 'campaigns-lib'
          }
        });
      });
    }

    // Save the updated campaign to the context to be saved outside of the select.
    setUpdatedCampaigns(selectOptions.map(({
      guid,
      objectId
    }) => ({
      campaignGuid: guid,
      objectId: objectId
    })));

    // Update the selected campaign guid in the select.
    setSelectedCampaignGuids(updatedCampaignGuidsArray);

    // Invoke the select callback prop for consumers to use.
    onChange === null || onChange === void 0 || onChange((selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.guid) || null);
  }, [client.cache, objectType, onChange, onFailure, onSuccess, save, selectedAssetCrmId, selectedCampaignGuids, setSelectedCampaignGuids, setUpdatedCampaigns]);
}
export default useHandleCampaignChange;